import { Location } from '@cpd-app/core-module/models';
import { createAction, props } from '@ngrx/store';

export const putPreferredLocation = createAction(
  '[Location] Put Preferred Location',
  props<{ locationModel: Location }>()
);

export const putPreferredLocationError = createAction(
  '[Location] Put Preferred Location Error',
  props<{ error: any }>()
);

export const putPreferredLocationSuccess = createAction(
  '[Location] Put Preferred Location Success',
  props<{ data: any }>()
);

export const deletePreferredLocation = createAction(
  '[Location] Delete Preferred Location',
  props<{ locationModel: Location }>()
);

export const deletePreferredLocationError = createAction(
  '[Location] Delete Preferred Location Error',
  props<{ error: any }>()
);

export const deletePreferredLocationSuccess = createAction(
  '[Location] Delete Preferred Location Success',
  props<{ data: any }>()
);

export const receivedLocationsListSuccess = createAction(
  '[Location] Received Locations',
  props<{ data: Location[] }>()
);

export const loadLocationsListFailure = createAction(
  '[Location] Load Locations List Failure',
  props<{ error: any }>()
);
export const searchLocations = createAction(
  '[Location] Search Locations',
  props<{ searchTerm: string }>()
);
export const getHotspots = createAction('[Location] Get Hospots');

export const getHotSpotsSuccess = createAction(
  '[Location] Get Hospots Success ',
  props<{ data: any[] }>()
);
export const getHotSpotsFailure = createAction(
  '[Location] Get Hospots Failure',
  props<{ error: any }>()
);
